export function initCategory() {
  console.log('category');
  handleContentLoaded();

  document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    handleContentLoaded();
  });
}

function handleContentLoaded() {}
